import { useMemo } from "react";

// Define the possible environments
export enum EnvironmentEnum {
  DEVELOPMENT = "development",
  STAGING = "staging",
  PRODUCTION = "production",
  CORPORATE = "corporate",
}

export function getEnvironment(): EnvironmentEnum {
  const hostname = window.location.hostname;

  if (
    hostname === "localhost" ||
    hostname.endsWith(".local") ||
    hostname.includes("dev")
  ) {
    return EnvironmentEnum.DEVELOPMENT;
  }

  return EnvironmentEnum.PRODUCTION;
}

/** Dedicated host that serves the Cam.LEX demo as its sole entry point. */
export const CAMLEX_HOST = "camlex.aksarasystems.com";

/**
 * Whether the app is being served on the Cam.LEX subdomain. When true, the
 * router serves the Cam.LEX deck at the root path instead of the demo hub
 * (`camlex.localhost` / a hosts alias works for local testing).
 */
export function isCamlexHost(): boolean {
  const hostname = window.location.hostname;
  return hostname === CAMLEX_HOST || hostname.startsWith("camlex.");
}

const useEnvironment = () => {
  const environment = useMemo(() => getEnvironment(), []);

  return {
    environment,
    isCorporate: environment === EnvironmentEnum.CORPORATE,
  };
};

export default useEnvironment;
